import React from 'react';
import Card from '../../common/Cards';
import protectWhatMatters from '../../../assets/images/home/protect-what-matters.webp';
import borrowResponsibly from '../../../assets/images/home/borrow-responsibility.webp';
import compareProducts from '../../../assets/images/home/compare-financial-products.webp';

const features = [
  {
    title: 'Protect What Matters',
    description: 'Secure your future with comprehensive insurance and protection plans tailored to your needs.',
    image: protectWhatMatters,
  },
  {
    title: 'Borrow Responsibly',
    description: 'Access flexible loan options with competitive rates from trusted financial institutions.',
    image: borrowResponsibly,
  },
  {
    title: 'Compare Financial Products',
    description: 'Make informed decisions by comparing various financial products and services.',
    image: compareProducts,
  },
];

const HowSimfinance = () => {
  return (
    <section className="py-16 bg-white sm:py-24">
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            How SimFinance Helps You
          </h2>
          {/* <p className="max-w-2xl mx-auto mt-4 text-lg text-gray-600">
            Discover how our platform makes financial management easier and more accessible for you
          </p> */}
        </div>

        <div className="grid grid-cols-1 gap-8 mt-16 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, index) => (
            <Card
              key={index}
              image={feature.image}
              title={feature.title}
              description={feature.description}
              className="transition-transform duration-300 transform hover:-translate-y-2"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowSimfinance;